import { render } from "./SupportShow.vue?vue&type=template&id=5d0072b3&scoped=true"
import script from "./SupportShow.vue?vue&type=script&lang=js"
export * from "./SupportShow.vue?vue&type=script&lang=js"

import "./SupportShow.vue?vue&type=style&index=0&id=5d0072b3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0072b3"]])

export default __exports__